import React from 'react';

const RedoIcon = () => {
  return (
    <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8 21c0 .274-.225.5-.5.5A.501.501 0 0 1 7 21v-5.501a2.5 2.5 0 0 1 2.5-2.5h11.795L18.148 9.85a.502.502 0 0 1 0-.706.502.502 0 0 1 .706 0l4 4a.502.502 0 0 1 0 .707l-4 4a.502.502 0 0 1-.706 0 .502.502 0 0 1 0-.706l3.147-3.147H9.5a1.5 1.5 0 0 0-1.5 1.5v5.5z"
        fill="currentColor"
      />
    </svg>
  );
};

export default RedoIcon;
